<mat-tab-group dynamicHeight animationDuration="0ms"  [(selectedIndex)]="selectedTabIndex" (click)="tabClick($event)" class="route-options-tabs">
    <mat-tab class="hiddenTab"></mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            {{optionToLeaveSelected().label | transloco}}
            <mat-icon class="tab-icon" matSuffix>{{selectedTabIndex === 1 ? 'arrow_drop_down' : 'arrow_drop_up'}}</mat-icon>
         </ng-template>
        <app-route-form-date-selector></app-route-form-date-selector>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            {{'routeForm.moreOptions' | transloco}}
            <mat-icon class="tab-icon" matSuffix>{{selectedTabIndex === 2 ? 'arrow_drop_down' : 'arrow_drop_up'}}</mat-icon>
        </ng-template>
        <app-route-form-more-options></app-route-form-more-options>
    </mat-tab>
</mat-tab-group>